import React from 'react';
import './OrderHistoryItem.scss';
import { Card } from 'antd';
import { FormattedDate, FormattedTime, FormattedMessage } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import DownloadTicketsButton from 'Components/DownloadTicketsButton/DownloadTicketsButton';
import DownloadConfirmationLink from 'Components/DownloadConfirmationLink/DownloadConfirmationLink';

interface IProps {
  orderHistoryItem: Julius.Website.OrderSmallViewModel;
}

const OrderHistoryItem: React.SFC<IProps> = ({
  orderHistoryItem: {
    orderID,
    barcode,
    performanceName,
    performanceDate,
    extraItems,
    isPaid,
    expireDate,
    imageUrl,
    deliveryMethod,
  },
}) => {

  const cardCover = (
    <img className='image' alt={ performanceName } src={ imageUrl } />
  );

  return (
    <div className='order-history-item'>
      <Card cover={ cardCover } bordered={ false }>
        <div className='name'>
          <span className='sub-title'>{ performanceName }</span>
          { extraItems.length ?
            <span>{ extraItems.join(', ') }</span> :
            <FormattedText
              displayName='Inga extra tillval'
              formattedName='order.noextras'
            />
          }
        </div>
        <div className='time'>
          <span className='sub-title capitalize'>
            <FormattedDate 
              value={ performanceDate }
              month='long'
              day='numeric'
              year='numeric'
            />
          </span>
          <span className='capitalize'>
            <FormattedTime 
              value={ performanceDate }
              hour='numeric'
              minute='numeric'
              weekday='long'
            />
          </span>
        </div>
        <div className='order-id'>
          <FormattedText 
            style='sub-title'
            displayName='Bokningsnummer'
            formattedName='order.orderID'
          />
          <span>{ orderID }</span>
        </div>
        <div className='status'>
          <FormattedText 
            style='sub-title'
            displayName='Status'
            formattedName='global.status'
          />
          { isPaid ?
            <FormattedText
            displayName='Betald'
            formattedName='order.paid'
            /> :
            <FormattedMessage 
              id='order.expires'
              defaultMessage='Reserverad'
              values={ { 
                expireDate: (
                  <div>
                    <FormattedTime 
                      value={ expireDate } 
                      day='numeric' 
                      month='numeric' 
                      year='numeric' />
                  </div>),
              } } 
            />
          }
        </div>
        <DownloadConfirmationLink { ... { orderID } } />
        { isPaid && 
          <div className='ticket-button-container'>
            <DownloadTicketsButton 
              { ... { 
                orderID, 
                orderBarcode: barcode, 
                deliveryCode: deliveryMethod,
              } }
            />
          </div>
        }
      </Card>
    </div>
  );
}

export default OrderHistoryItem;


// WEBPACK FOOTER //
// ./src/pages/OrderHistoryPage/OrderHistoryItem/OrderHistoryItem.tsx